import { injectReducer, injectTranslations } from 'ia-react-core';
import { FC } from 'react';
import { compose } from 'redux';
import fr from './translations/fr';
import en from './translations/en';
import LoginPage, { LoginPageProps } from './LoginPage';
import LoginPageState from './interfaces/LoginPageState';
import loginPageReducer from './LoginPage.reducer';
import { LoginPageActions } from './LoginPage.actions';

const initialState = {
  errorCounter: 0,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any;

export default compose<FC<LoginPageProps>>(
  injectTranslations('LoginPage', [
    { language: 'fr', resource: fr },
    { language: 'en', resource: en },
  ]),
  injectReducer<LoginPageProps, LoginPageState, LoginPageActions>({
    key: 'FormPage',
    reducer: loginPageReducer,
    initialState,
    useScope: true,
    cleanState: true,
  }),
)(LoginPage);

export * from './LoginPage';
